export default __webpack_public_path__ + "static/car1-739e270e365331b3fa40e49d2de1c7d1.glb";